import type { CFORec } from '../../financialintel/framework';
import { cn } from '../../lib/cn';

type Props = { recommendations?: CFORec[] };

export function AICFOAdvisorPanel({ recommendations = [] }: Props) {
  return (
    <div className="space-y-2">
      {recommendations.map((r) => (
        <div key={r.title} className="flex items-start justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <span className="rounded bg-brand-100 px-1.5 py-0.5 text-xs font-medium text-brand-700 dark:bg-brand-950 dark:text-brand-300">
              {r.type}
            </span>
            <p className="mt-1 text-sm font-medium">{r.title}</p>
            <p className="mt-0.5 text-xs text-success-600">{r.impact}</p>
          </div>
          <div className="shrink-0 text-right">
            <p className={cn(
              'text-lg font-semibold',
              r.confidence >= 90 ? 'text-success-600' : r.confidence >= 80 ? 'text-brand-600' : 'text-warning-600',
            )}>
              {r.confidence}%
            </p>
            <p className="text-xs text-slate-500">confidence</p>
          </div>
        </div>
      ))}
    </div>
  );
}
